import { render, staticRenderFns } from "./ImporterMenu.vue?vue&type=template&id=49df8e4a&scoped=true&"
import script from "./ImporterMenu.vue?vue&type=script&lang=js&"
export * from "./ImporterMenu.vue?vue&type=script&lang=js&"
import style0 from "./ImporterMenu.vue?vue&type=style&index=0&id=49df8e4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df8e4a",
  null
  
)

export default component.exports